import axiosInstance from "../api";
import { notification } from "antd";

// getRecommendatedDestination
export const getRecommendatedDestination = async ({
  skip = 0,
  limit = 10,
  name = "",
} = {}) => {
  try {
    const params = new URLSearchParams();
    params.append("skip", skip);
    params.append("limit", limit);
    if (name) params.append("search", name);

    const response = await axiosInstance.get(
      `/get_recommendated_destination?${params.toString()}`
    );

    if (response?.data?.status_code === 200) {
      return response?.data?.data;
    }
    notification.error({
      message: "Error Fetching data",
      description:
        response?.data?.message || "Failed to fetch data list.",
      duration: 3,
    });
  } catch (error) {
    notification.error({
      message: "Error Fetching data",
      description:
        error.response?.data?.message || "Failed to fetch data list.",
      duration: 3,
    });
    throw new Error("Error fetching data list");
  }
};


export const createRecommendatedDestination = async (data) => {
    try {
      const formData = new FormData();
      formData.append("destination_text", data.destination_text);
      formData.append("destination_address", data.destination_address);
      if (Array.isArray(data.recommendation_ids)) {
        formData.append("recommendation_ids", data.recommendation_ids.join(","));
      }
      if (data.image) {
        formData.append("image", data.image);
      }
  
      const response = await axiosInstance.post("/create_recommendated_destination", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
  
      if (response.data.status_code === 200) {
        notification.success({
          message: "Success",
          description: response.data.message,
          duration: 3,
        });
        return response.data.data;
      } else {
        notification.error({
          message: "Creation Error",
          description:
            response.data.message ||
            "An error occurred while creating the recommendated destination.",
          duration: 3,
        });
      }
    } catch (error) {
      notification.error({
        message: "Creation Failed",
        description:
          error.response?.data?.message || "An unexpected error occurred.",
        duration: 3,
      });
      throw new Error(
        error.response?.data?.message || "Error creating recommendated destination"
      );
    }
  };
  
  export const updateRecommendatedDestination = async (data) => {
    try {
      const formData = new FormData();
      if (data.destination_text) {
        formData.append("destination_text", data.destination_text);
      }
      if (data.destination_address) {
        formData.append("destination_address", data.destination_address);
      }
      if (Array.isArray(data.recommendation_ids)) {
        formData.append("recommendation_ids", data.recommendation_ids.join(","));
      }
      if (data.image) {
        formData.append("image", data.image);
      }
      if (data.id) {
        formData.append("id", data.id);
      }
  
      const response = await axiosInstance.put(
        `/update_recommendated_destination`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
  
      if (response.data.status_code === 200) {
        notification.success({
          message: "Success",
          description: response.data.message,
          duration: 3,
        });
        return response.data.data;
      } else {
        notification.error({
          message: "Update Error",
          description:
            response.data.message ||
            "An error occurred while updating the recommendated destination.",
          duration: 3,
        });
        return false
      }
    } catch (error) {
      notification.error({
        message: "Update Failed",
        description:
          error.response?.data?.message || "An unexpected error occurred.",
        duration: 3,
      });
      throw new Error(
        error.response?.data?.message || "Error updating recommendated destination"
      );
    }
  };
  
  export const activateDeactivateRecommendatedDestination = async (updateId, active) => {
    try {
      const payload = { id : updateId, active: active}
      const response = await axiosInstance.put(`/activate_deactivate_recommendated_destination`, payload);
  
      if (response.data.status_code === 200) {
        notification.success({
          message: "Success",
          description: response.data.message,
          duration: 3,
        });
        return response.data.data;
      } else {
        notification.error({
          message: "Update Error",
          description: response.data.message || "An error occurred during update.",
          duration: 3,
        });
      }
    } catch (error) {
      notification.error({
        message: "Update Failed",
        description: error.response?.data?.message || "An unexpected error occurred.",
        duration: 3,
      });
      throw new Error(error.response?.data?.message || "Error");
    }
  };


export const getTrendingDestination = async ({
    skip = 0,
    limit = 10,
    name = "",
  } = {}) => {
    try {
      const params = new URLSearchParams();
      params.append("skip", skip);
      params.append("limit", limit);
      if (name) params.append("search", name);
  
      const response = await axiosInstance.get(
        `/get_trending_destination?${params.toString()}`
      );
  
      if (response?.data?.status_code === 200) {
        return response?.data?.data;
      }
      notification.error({
        message: "Error Fetching data",
        description:
          response?.data?.message || "Failed to fetch data list.",
        duration: 3,
      });
    } catch (error) {
      notification.error({
        message: "Error Fetching data",
        description:
          error.response?.data?.message || "Failed to fetch data list.",
        duration: 3,
      });
      throw new Error("Error fetching data list");
    }
  };
  
  
  export const createTrendingDestination = async (data) => {
      try {
        const formData = new FormData();
        formData.append("destination_text", data.destination_text);
        formData.append("destination_address", data.destination_address);
        if(data.itinerary_id){
          formData.append("itinerary_id", data.itinerary_id);
        }
        if (Array.isArray(data.recommendation_ids)) {
          formData.append("recommendation_ids", data.recommendation_ids.join(","));
        }
        if (data.image) {
          formData.append("image", data.image);
        }
    
        const response = await axiosInstance.post("/create_trending_destination", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
    
        if (response.data.status_code === 200) {
          notification.success({
            message: "Success",
            description: response.data.message,
            duration: 3,
          });
          return response.data.data;
        } else {
          notification.error({
            message: "Creation Error",
            description:
              response.data.message ||
              "An error occurred while creating the trending destination.",
            duration: 3,
          });
        }
      } catch (error) {
        notification.error({
          message: "Creation Failed",
          description:
            error.response?.data?.message || "An unexpected error occurred.",
          duration: 3,
        });
        throw new Error(
          error.response?.data?.message || "Error creating trending destination"
        );
      }
    };
    
    export const updateTrendingDestination = async (data) => {
      try {
        const formData = new FormData();
        if (data.destination_text) {
          formData.append("destination_text", data.destination_text);
        }
        if (data.destination_address) {
          formData.append("destination_address", data.destination_address);
        }
        if (data.itinerary_id) {
          formData.append("itinerary_id", data.itinerary_id);
        }
        if (Array.isArray(data.recommendation_ids)) {
          formData.append("recommendation_ids", data.recommendation_ids.join(","));
        }
        if (data.image) {
          formData.append("image", data.image);
        }
        if (data.id) {
          formData.append("id", data.id);
        }
        if (data.is_itinerary_remove) {
          formData.append("is_itinerary_remove", data.is_itinerary_remove);
        }
        
    
        const response = await axiosInstance.put(
          `/update_trending_destination`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
    
        if (response.data.status_code === 200) {
          notification.success({
            message: "Success",
            description: response.data.message,
            duration: 3,
          });
          return response.data.data;
        } else {
          notification.error({
            message: "Update Error",
            description:
              response.data.message ||
              "An error occurred while updating the trending destination.",
            duration: 3,
          });
          return false
        }
      } catch (error) {
        notification.error({
          message: "Update Failed",
          description:
            error.response?.data?.message || "An unexpected error occurred.",
          duration: 3,
        });
        throw new Error(
          error.response?.data?.message || "Error updating trending destination"
        );
      }
    };
    
    export const activateDeactivateTrendingDestination = async (updateId, active) => {
      try {
        const payload = { id : updateId, active: active}
        const response = await axiosInstance.put(`/activate_deactivate_trending_destination`, payload);
    
        if (response.data.status_code === 200) {
          notification.success({
            message: "Success",
            description: response.data.message,
            duration: 3,
          });
          return response.data.data;
        } else {
          notification.error({
            message: "Update Error",
            description: response.data.message || "An error occurred during update.",
            duration: 3,
          });
        }
      } catch (error) {
        notification.error({
          message: "Update Failed",
          description: error.response?.data?.message || "An unexpected error occurred.",
          duration: 3,
        });
        throw new Error(error.response?.data?.message || "Error");
      }
    };


    export const getPlaceList = async (data) => {
      try {
    
        const payload = {
          input_text : data?.input_text,
          session_token: data?.session_token
        }
        const response = await axiosInstance.post(`/place-autocomplete/`, payload);
    
        if (response.data.status_code === 200) {
          return response.data.data;
        } else {
          notification.error({
            message: "Error",
            description: response.data.message || "An error occurred fetching the data.",
            duration: 3,
          });
        }
      } catch (error) {
        notification.error({
          message: "Update Failed",
          description: error.response?.data?.message || "An error occurred fetching the data.",
          duration: 3,
        });
      }
    };